import { render, staticRenderFns } from "./NewEditAulaPagePolivalenciaInfantil.vue?vue&type=template&id=b964e28e&scoped=true"
import script from "./NewEditAulaPagePolivalenciaInfantil.vue?vue&type=script&lang=js"
export * from "./NewEditAulaPagePolivalenciaInfantil.vue?vue&type=script&lang=js"
import style0 from "./NewEditAulaPagePolivalenciaInfantil.vue?vue&type=style&index=0&id=b964e28e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b964e28e",
  null
  
)

export default component.exports